module.exports = __webpack_public_path__ + "img/tableau.c328b153.webp";